/**
 * @file Popper
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import React from 'react';
import { PopperProvider, usePopper } from '@tencent/glue-react-popper';
export function Popper(props) {
  var children = props.children;
  var popper = usePopper();
  return React.createElement(PopperProvider, {
    value: popper
  }, children);
}